import React from 'react';
const testimonials = [{
  name: 'David G.',
  role: 'U12s Head Coach',
  city: 'Leicester',
  text: "Honestly, sessions used to take me 2 hours to prep. Now it's 5 minutes. The lads turn up and we run high-tempo work from the first whistle.",
  stars: 5
}, {
  name: 'James R.',
  role: 'Seniors 2nd XV Coach',
  city: 'Bath',
  text: "The season planner is spot on. I handed it to our DOR and he said it was the most professional programme he'd seen at amateur level. Worth every penny.",
  stars: 5
}, {
  name: 'Sarah L.',
  role: 'Minis Coordinator',
  city: 'Gloucester',
  text: 'The diagrams and coaching cues are brilliant — even our newer volunteer coaches can run a proper session now. Total game-changer for the club.',
  stars: 5
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 border-t border-border-light/50" data-id="element-334">
      <div className="max-w-5xl mx-auto" data-id="element-335">
        <div className="text-center mb-14" data-id="element-336">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-337">
            What UK coaches are saying
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-338">
            Over <span className="text-primary font-bold" data-id="element-339">15,000 coaches</span>{' '}
            have already chosen CoachLabs resources
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-340">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden group" data-id="element-341">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-342"></div>

              <div className="flex items-center gap-0.5 relative z-10" data-id="element-343">
                {Array.from({
              length: t.stars
            }).map((_, j) => <span key={j} className="text-secondary text-lg" data-id="element-344">
                    ⭐
                  </span>)}
              </div>

              <p className="text-text-main text-base leading-relaxed font-medium relative z-10 flex-1" data-id="element-345">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light/50 relative z-10" data-id="element-346">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 flex items-center justify-center shadow-inner flex-shrink-0" data-id="element-347">
                  <span className="text-sm font-bold text-primary" data-id="element-348">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-349">
                  <p className="text-text-main font-bold text-sm" data-id="element-350">{t.name}</p>
                  <p className="text-text-sec text-xs" data-id="element-351">
                    {t.role} · {t.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}